import React from "react";
import AppShell from "../components/ui/AppShell";
import PageHeader from "../components/ui/PageHeader";

const stats = [
  { label: "Total Agents", value: "—", tone: "#171717" },
  { label: "Assisted Bookings", value: "—", tone: "#f26b2b" },
  { label: "Active Clients", value: "—", tone: "#6b6560" },
  { label: "Booking Status", value: "—", tone: "#3d6f8c" },
];

const Dashboard = () => {
  return (
    <AppShell>
      <PageHeader
        title="Dashboard"
        description="Welcome back. Here's an overview of your portal."
      />

      <div className="row g-3 mb-3">
        {stats.map((s, i) => (
          <div className="col-sm-6 col-xl-3" key={i}>
            <div className="app-stat-card">
              <div
                style={{
                  fontSize: 11,
                  color: "var(--vp-text-muted)",
                  fontWeight: 650,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                }}
              >
                {s.label}
              </div>
              <div
                className="fw-bold mt-2"
                style={{
                  fontSize: "1.55rem",
                  letterSpacing: "-0.03em",
                  color: s.tone,
                }}
              >
                {s.value}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="card p-4">
        <h5 className="fw-semibold mb-1" style={{ fontSize: "1.05rem" }}>
          Visa Portal
        </h5>
        <p className="mb-0" style={{ color: "var(--vp-text-secondary)", fontSize: 13.5 }}>
          Use the top navigation to move between VFS, TLS, people, access, and booking tools.
        </p>
      </div>
    </AppShell>
  );
};

export default Dashboard;
